export default "__VITE_ASSET__RKPwN4T5__"